import {decorate, observable, action} from 'mobx';
import _ from 'lodash';

class SparePartsFinderFiltersBasketStore {
    ids = [];
    basketIsOpen = false;

    addToBasketIfNotExistsSingle(id) {
        this.ids = _.xor(this.ids, [id]);
    }

    addToBasketIfNotExistsMany(ids) {
        this.ids = _.union(this.ids, ids);
    }

    removeFromBasketMany(ids) {
        this.ids = this.ids.filter(x => !ids.includes(x));
    }

    isInBasket(id) {
        return this.ids.includes(id);
    }

    hasAny() {
        return this.ids.length > 0
    }

    setBasketIsOpen(value) {
        this.basketIsOpen = value;
    }

    clearBasket() {
        this.ids = [];
    }
}

decorate(SparePartsFinderFiltersBasketStore, {
    ids: observable,
    basketIsOpen: observable,
    addToCartIfNotExistsSingle: action,
    addToCartIfNotExistsMany: action,
    removeFromBasketMany: action,
    setBasketIsOpen: action
})

const store = new SparePartsFinderFiltersBasketStore();
export default store;